import { ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';

export function hasEnoughSearchCharacters(value: string, minSearchCharacters?: number): boolean {
    if (minSearchCharacters === undefined) return true;
    return value.trim().length >= minSearchCharacters;
}

/** Opt-in min-length gate; undefined min means no gate (default). */
export function shouldBlockMinSearchCharacters(value: string, minSearchCharacters?: number): boolean {
    return minSearchCharacters !== undefined && !hasEnoughSearchCharacters(value, minSearchCharacters);
}

/** Builds list fetch params; active search wins and empty search is omitted. */
export function buildPaginatedFetchParams<D extends string | number>(
    queryParams: ApiQueryParams<D> | undefined,
    args: { index: string; size: string; accountId: string | null | undefined; search: string }
): ApiQueryParams<DefaultQueryParams | D> {
    const restQueryParams = { ...(queryParams ?? {}) } as ApiQueryParams<DefaultQueryParams | D>;
    delete restQueryParams[DefaultQueryParams.SEARCH];
    return {
        ...restQueryParams,
        [DefaultQueryParams.INDEX]: args.index,
        [DefaultQueryParams.SIZE]: args.size,
        [DefaultQueryParams.ACCOUNT_ID]: args.accountId ?? undefined,
        ...(args.search ? { [DefaultQueryParams.SEARCH]: args.search } : {})
    };
}

export function canLoadNextPage(count: number, pageSize: string, index: number): boolean {
    const size = Number.parseInt(pageSize, 10);
    return count / size > 1 && size * index < count;
}
